import { useMutation, useQueryClient } from "@tanstack/react-query";

import { usersQueryKey } from "@/hooks/queries/useGetUsers";
import { guacHttpClient } from "@/lib/http";
import {
  HttpResponse,
  StafferEmployeeReportsResponse,
  UpdateStafferEmployeeReportsRequest,
  User,
} from "@/types";

export const useUpdateSetStafferEmployeeReports = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      userId,
      receivesStafferEmployeeReports,
    }: {
      userId: number;
      receivesStafferEmployeeReports: boolean;
    }) => {
      const path = `user-settings/${userId.toString()}/staffer-employee-reports`;
      const res = await guacHttpClient.patch<
        StafferEmployeeReportsResponse,
        HttpResponse<StafferEmployeeReportsResponse>,
        UpdateStafferEmployeeReportsRequest
      >(path, { receivesStafferEmployeeReports });
      return res.data;
    },
    onSuccess: (updated) => {
      queryClient.setQueryData<User[]>(usersQueryKey(), (users) =>
        users?.map((user) =>
          user.id === updated.userId
            ? {
                ...user,
                userSettings: {
                  ...user.userSettings,
                  receivesStafferEmployeeReports:
                    updated.receivesStafferEmployeeReports,
                },
              }
            : user,
        ),
      );
    },
  });
};
